import React, { useEffect, useState } from 'react';
import './i18n';
import { useTranslation } from 'react-i18next';

import MyProfile from './my-profile';
import MyBooking from './my-booking';

/**
 * Combined account page: Profile editor + My Booking, with a left sidebar.
 *
 * The Profile tab shows editable name/email/phone fields and a single Apply
 * button. When phone and/or email are changed, the backend sends SMS/email
 * verifications and the reusable VerificationModal collects the codes.
 */
const ProfilePage = () => {
  const { t } = useTranslation();

  // 'profile' | 'booking' — the orders view mounts with data-active-tab="booking".
  const [activeTab, setActiveTab] = useState('profile');

  useEffect(() => {
    // The orders view mounts the same node with data-active-tab="booking".
    const node = document.getElementById('kurortlife_profile');
    if (node && node.dataset.activeTab === 'booking') {
      setActiveTab('booking');
      return;
    }
    // Restore the last selected tab so switching the site language
    // (full page reload) keeps the user on the same tab.
    const saved = sessionStorage.getItem('kurortlife_profile_tab');
    if (saved === 'profile' || saved === 'booking') {
      setActiveTab(saved);
    }
  }, []);

  const selectTab = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem('kurortlife_profile_tab', tab);
  };

  return (
    <div className="kurortlife-account">
      <div className="account-sidebar">
        <button
          type="button"
          className={`account-nav-item${activeTab === 'profile' ? ' is-active' : ''}`}
          onClick={() => selectTab('profile')}
        >
          {t('Profile')}
        </button>
        <button
          type="button"
          className={`account-nav-item${activeTab === 'booking' ? ' is-active' : ''}`}
          onClick={() => selectTab('booking')}
        >
          {t('My Booking')}
        </button>
      </div>

      <div className="account-content">
        {activeTab === 'profile' && <MyProfile />}
        {activeTab === 'booking' && <MyBooking />}
      </div>
    </div>
  );
};

export default ProfilePage;